var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pin with truck") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB461",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76B1C",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mster-icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pin-with-truck"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(12.500000, 5.000000)",
    fill: "url(#linearGradient-1)",
    stroke: "#D76C23",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4045143,3.74851158 C17.2780103,-1.24950386 8.97235429,-1.24950386 3.84487803,3.74851158 C-1.28162601,8.74368347 -1.28162601,16.8487527 3.84487803,21.8429767 C3.84487803,21.8429767 12.0931732,29.7290925 13.0323355,39.2132841 C13.0887241,39.7857858 13.1188629,39.4161241 13.1188629,40 C13.1188629,39.4151763 13.1480294,39.7838901 13.2063625,39.2094927 C14.1474692,29.7271968 22.4035421,21.8429767 22.4035421,21.8429767 C27.5319906,16.8487527 27.5319906,8.74368347 22.4045143,3.74851158 Z",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(15.000000, 12.500000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header/assets/logo/1024minus",
    transform: "translate(1.128906, 0.312500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7540726,9.69980983 C16.1370861,9.69980983 16.4459601,9.40634137 16.4459601,9.04243845 C16.4459601,8.67853535 16.1370861,8.38506438 15.7540726,8.38506438 C15.3731117,8.38506438 15.0642377,8.67853535 15.0642377,9.04243827 C15.0642377,9.40634119 15.3731117,9.69980983 15.7540726,9.69980983 M14.1628123,9.04243809 C14.1628123,8.20555731 14.8778813,7.53008833 15.754581,7.53008833 C16.6343879,7.53008833 17.3504739,8.2055591 17.3504739,9.04243863 C17.3504739,9.88029416 16.6343879,10.5547861 15.754581,10.5547859 C14.8773541,10.5547857 14.1628123,9.88029363 14.1628123,9.04243809",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.77201183,9.67046113 C6.15502537,9.6704613 6.46391819,9.3769898 6.46391819,9.01308688 C6.46391819,8.64918378 6.15502537,8.3557146 5.77201183,8.3557146 C5.39106976,8.3557146 5.08012431,8.64918378 5.08012431,9.01308652 C5.08012431,9.37698962 5.39054248,9.67046113 5.77201183,9.67046113 M4.17819043,9.01308634 C4.17819043,8.17523063 4.89531214,7.50073854 5.77201183,7.50073854 C6.65181873,7.50074033 7.36585207,8.17523242 7.36585207,9.01308706 C7.36585207,9.84996731 6.65181873,10.5254374 5.77201183,10.5254372 C4.89531214,10.525437 4.17819043,9.84996677 4.17819043,9.01308634",
    id: "Fill-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.45660799,2.08166817e-17 L10.9637011,0.0282691129 C11.5158967,0.0384388368 12.0867919,0.0807387334 12.6054109,0.276749247 C13.6787678,0.846831692 14.3916901,1.81497008 14.4963178,2.98155228 C14.7719166,2.98111214 14.9453734,2.98155765 15.2215371,2.98155765 C15.3528113,2.98155765 15.6087689,3.09275188 15.7210233,3.22501196 L17.2710239,5.35452781 L18.084431,5.61229561 C18.4170515,5.72821507 18.6583957,6.0727261 18.6585087,6.3929239 L18.7874856,7.29072945 L18.9610742,7.29072945 C19.1165469,7.29296772 19.1511403,7.44722404 19.1620626,7.56440488 L19.1618931,8.18505325 C19.1619873,8.45748699 18.9487395,8.67807911 18.6583957,8.67807732 L17.8057438,8.67809879 C17.6299896,7.71150804 16.7534971,7.10604805 15.7574434,7.05839671 C14.7412024,7.07383737 13.9161387,7.74017077 13.7144347,8.67809163 L7.79620796,8.67809879 C7.62700708,7.71491286 6.77134215,7.10598543 5.77551449,7.05839671 C4.7555637,7.07303581 3.95616724,7.74409982 3.75495284,8.67809163 L3.05607884,8.67809879 L1.54118018,8.6780809 C1.25657998,8.67807553 1.02233516,8.45748341 1.02233516,8.18504431 L1.02225983,7.05706198 L1.45660799,7.05706198 L1.45660799,2.08166817e-17 Z M14.8989538,3.52118639 L12.4916876,3.52118639 L12.7452912,5.00744394 C12.7453289,5.20545297 12.9797997,5.36596965 13.2690136,5.36597502 L16.6500934,5.3659607 L15.5921595,3.87973893 C15.468173,3.71749748 15.2745477,3.52120786 14.8989538,3.5212168 L14.8989538,3.52118639 L14.8989538,3.52118639 Z",
    id: "Fill-3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleMarker);
export default __webpack_public_path__ + "static/media/vehicle-marker.143db3da17500be7ba98edd9e049af58.svg";
export { ForwardRef as ReactComponent };